// extracted by mini-css-extract-plugin
export default {"graficoaluno":"GraficoDetalher_graficoaluno__JYm38"};